import Template from "../templates/CreateRole/CreateRoleTemplate";

const CreateRole = () => <Template />;

export default CreateRole;
